import { useEffect, useRef } from 'react';
import Image from 'next/image';
import Paso from '@/components/Paso';
import BotonPrimario from '@/components/Botones/Primario';
import cn from 'classnames';
import { useStore } from 'store/main';
import gsap from 'gsap';

import styles from 'styles/pages/index.module.scss';
import PopupAnimacion from './Animacion';

const defaultSteps = [
  'Revisaremos y validaremos tu postulación',
  'Te contactaremos vía mail o telefónicamente',
  'Podrás comenzar tu integración con HOP'
];
const defaultText =
  'Nos entusiasma la posibilidad de trabajar juntos para optimizar tus procesos logísticos y ofrecer a tus clientes la mejor experiencia de entrega posible\nA la brevedad, uno de nuestros asesores se pondrá en contacto contigo para validar tu postulación y acompañarte en cada paso del proceso de integración';

const PopUp = ({
  colorStep,
  colorButton,
  close,
  showSteps = true,
  steps = defaultSteps,
  text = defaultText
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const el = containerRef.current;
    const lines = el.querySelectorAll('.popup-line-js');
    const stepsEl = el.querySelectorAll('.popup-step-js');

    if (!lines.length && !stepsEl.length) return;

    const tl = gsap
      .timeline({ repeat: -1 })
      .fromTo(
        lines,
        { scaleX: 0 },
        { scaleX: 1, ease: 'none', duration: 1 }
      )
      .fromTo(
        stepsEl,
        { scale: 0 },
        { scale: 1, ease: 'back.out', stagger: 0.5 },
        0
      )
      .to(lines, { x: 1, duration: 2 });

    return () => { tl.kill(); };
  }, []);

  return (
    <div
      ref={containerRef}
      className={cn(
        // isPopUpOpen && 'opacity-0 invisible',
        'relative w-full sm:w-[100rem] pt-20 pb-20 pl-20 sm:pt-25 pr-20 sm:pb-60 sm:pl-56 rounded-[3rem] bg-white duration-40 overflow-hidden',
        styles.shadow
      )}
    >
      <button
        onClick={close}
        className="ml-auto w-43 h-43 rounded-full bg-grey flex items-center justify-center group"
      >
        <svg
          className="w-23 h-auto duration-40 group-hover:scale-90"
          viewBox="0 0 23 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1.17188 1.17236L22.1202 22.1207" stroke="#064246" strokeWidth="1.25417" />
          <path d="M22.123 1.17236L1.1747 22.1207" stroke="#064246" strokeWidth="1.25417" />
        </svg>
      </button>
      <div className="flex flex-col sm:flex-row items-center">
        <div className="hidden sm:block relative w-[24.7rem] h-[40.6rem]">
          <PopupAnimacion />
        </div>
        <div>
          <div className="mb-20 mt-20 sm:mb-40 sm:mt-0">
            <h4 className="title-4 text-cyan-dark">¡Gracias por tu contacto!</h4>
          </div>
          <div className="max-w-[43rem] mb-20 sm:mb-40">
            <p className="p2 !text-12 sm:!text-14 text-black opacity-60">{text}</p>
          </div>
          {showSteps && (
            <>
              <div className="mb-20">
                <p className="c1 text-black">Próximos pasos:</p>
              </div>
              <div className="flex flex-row sm:flex-col">
                <div className="relative flex flex-col sm:flex-row items-center justify-between mb-25 sm:max-w-[49rem] mr-30 sm:mr-0">
                  <div className="hidden sm:block absolute top-1/2 -translate-y-1/2 left-40">
                    <svg
                      width="408"
                      height="8"
                      viewBox="0 0 408 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 4L404 4"
                        stroke="#EEEEEE"
                        strokeOpacity="0.5"
                        strokeWidth="7"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="hidden sm:block absolute top-1/2 -translate-y-1/2 left-40 origin-left popup-line-js">
                    <svg
                      width="408"
                      height="9"
                      viewBox="0 0 408 9"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.99999 5L404 4"
                        stroke="url(#paint0_linear_3709_4269)"
                        strokeWidth="7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_3709_4269"
                          x1="428.12"
                          y1="2.81749"
                          x2="351.402"
                          y2="167.205"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#EE4424" />
                          <stop offset="0.571417" stopColor="#FD813E" />
                          <stop offset="1" stopColor="#22CDC6" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="mb-30 sm:mb-0 popup-step-js">
                    <Paso bgColor={colorStep} />
                  </div>
                  <div className="mb-30 sm:mb-0 popup-step-js">
                    <Paso bgColor={colorStep} number="2" />
                  </div>
                  <div className="popup-step-js">
                    <Paso bgColor={colorStep} number="3" />
                  </div>
                </div>
                <div className="flex flex-col sm:flex-row items-start justify-around sm:justify-between mb-20 sm:mb-45">
                  <div className="sm:max-w-[17rem] relative -top-7 sm:top-0">
                    <p className="p2 !text-12 sm:!text-14 text-cyan-dark">{steps[0]}</p>
                  </div>
                  <div className="sm:max-w-[19rem] relative top-5 sm:top-0 sm:left-30">
                    <p className="p2 !text-12 sm:!text-14 text-cyan-dark">{steps[1]}</p>
                  </div>
                  <div className="max-w-[17rem] relative top-6 sm:top-0 sm:left-100">
                    <p className="p2 !text-12 sm:!text-14 text-cyan-dark">{steps[2]}</p>
                  </div>
                </div>
              </div>
              <div className="max-w-full sm:max-w-[23rem]">
                <BotonPrimario
                  label={'volver al inicio'}
                  textColor="text-white"
                  bgColor={colorButton}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default PopUp;
